import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { Button, Form, Input } from "antd";
import { useState } from "react";
import { useDispatch } from 'react-redux';
import { Link, useHistory } from "react-router-dom";
import { loginAccount } from "../../../redux/user/actions";
import { Container } from "../../../style/common";
import { FormContainer } from "./Login.styles";


const Login = () => {
  const history = useHistory()
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()
  
  const onFinish = (values) => {
    setLoading(true)
    dispatch(loginAccount(values,setLoading,history))
  };

  return (
    <Container>
      <FormContainer>
        <Form
          name="normal_login"
          className="login-form"
          initialValues={{
            remember: true,
          }}
          onFinish={onFinish}
        >
          <Form.Item
            name="email"
            rules={[
              {
                required: true,
                message: "Please input your email!",
              },
            ]}
          >
            <Input
              prefix={<UserOutlined className="site-form-item-icon" />}
              placeholder="email"
            />
          </Form.Item>
          <Form.Item
            name="password"
            rules={[
              {
                required: true,
                message: "Please input your Password!",
              },
            ]}
          >
            <Input
              prefix={<LockOutlined className="site-form-item-icon" />}
              type="password"
              placeholder="Password"
            />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              className="login-form-button"
              loading={loading}
            >
              Log in
            </Button>
            &nbsp; &nbsp; <Link style={{color:'white'}} to="/auth/sineUp">Or register now!</Link>
          </Form.Item>
        </Form>
      </FormContainer>
    </Container>
  );
};

export default Login;
